export type Environment = 'production' | 'homolog';

// Versão da aplicação
export const APP_VERSION = '3.2.12';

const config = {
  production: {
    apiBaseUrl: 'https://api.vivofree.com.br/39dd54c0-9ea1-4708-a9c5-5120810b3b72/',
    headerEnrichmentUrl: 'https://mdivo.terra.com.br/identify/v2/',
    ga4MeasurementId: 'G-XR6NQW6L1M' // Substituir pelo ID real do GA4 de produção
  },
  homolog: {
    apiBaseUrl: 'https://api.vivofree.com.br/39dd54c0-9ea1-4708-a9c5-5120810b3b72/',
    headerEnrichmentUrl: 'https://mdivo.terra.com.br/identify/v2/',
    ga4MeasurementId: 'G-XR6NQW6L1M' // Substituir pelo ID real do GA4 de homolog
  }
};

// Por padrão, usar homolog. Pode ser alterado via variável de ambiente
const currentEnv: Environment = (import.meta.env.VITE_ENV as Environment) || 'homolog';

export const environment = config[currentEnv];
export const isProduction = currentEnv === 'production';

